// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"169":"7ff8e3ca","630":"238643d5","954":"57b9e80e"}[chunkId] + ".chunk.js";
};